import {
  AppState,
	BackendService,
	ConfigService,
	MapService,
  MenuState,
	StateService
}										  from '../../'
import {
  Component,
  Renderer2,
  ViewChildren,
  QueryList,
  AfterViewInit,
  ElementRef
}                     from '@angular/core'
import { MenuConfig }	from '../../'

@Component({
  selector:			'electra-menu',
  styleUrls:		[ './menu.component.scss' ],
  templateUrl:	'./menu.component.html'
})
export class MenuComponent implements AfterViewInit {
  @ViewChildren('menuButton') menuButtonList: QueryList<ElementRef>;

	config:			MenuConfig;
	buttons			= [ false, false, false, false ];
	buttonCount	= 0;
	space				= 0;
	state:			MenuState;
  appState:   AppState;

  get button4Text(): string {
    return this.configService.mobile ? 'Search' : 'More';
  }

  get button4Class(): string {
    return this.configService.mobile ? '' : 'desktop';
  }

  get iabImage(): string {
    var image = this.config.iab ? this.config.iab.image : '';

    if (image && this.appState.iab && !this.configService.mobile) {
      image = image.substring(0, image.length - 4) + 'Selected.svg';
    }

    return image;
  }

	constructor(public backendService: BackendService, public configService: ConfigService, public mapService: MapService, public stateService: StateService, public renderer: Renderer2) {
		configService.menu.subscribe(data => { this.gotConfig(data); });
		stateService.menu.subscribe(data => { this.gotState(data); });
    stateService.app.subscribe(data => { this.gotAppState(data); });
  }
  
  ngAfterViewInit() {
    this.addEventHandlers();
  }

	getFilterStyle() {
		var offset = this.buttons[0] ? 1 : 0;

		return this.configService.mobile ? {
			left: this.buttons[1] ? ((offset * (60 + this.space) + this.space) + 'px') : '-100px'
		} : {
			top: this.buttons[1] ? (offset * 60 + 'px') : '-100px'
		};
	}

	getFilterColor() {
		return this.state.filter === 'filter' ? this.config.unselected : this.config.selected;
	}

	getIABStyle() {
		var offset = this.buttons[0] && this.buttons[1] ? 2 : (this.buttons[0] || this.buttons[1] ? 1 : 0);

		return this.configService.mobile ? {
			left: this.buttons[2] ? ((offset * (60 + this.space) + this.space) + 'px') : '-100px'
		} : {
			top: this.buttons[2] ? (offset * 60 + 'px') : '-100px'
		};
	}

	getLegendStyle() {
		return this.configService.mobile ? {
			left: this.buttons[0] ? this.space + 'px' : '-100px'
		} : {
			top: this.buttons[0] ? '0px' : '-100px'
		};
	}

	getLegendColor() {
		return this.state.legend === 'legend' ? this.config.unselected : this.config.selected;
	}

	getMoreStyle() {
		var offset = this.buttons[0] && this.buttons[1] && this.buttons[2] ? 3 : ((this.buttons[0] && this.buttons[1]) || (this.buttons[0] && this.buttons[2]) || (this.buttons[1] && this.buttons[2]) ? 2 : (this.buttons[0] || this.buttons[1] || this.buttons[2] ? 1 : 0));

		return this.configService.mobile ? {
			left: this.buttons[3] ? ((offset * (60 + this.space) + this.space) + 'px') : '-100px'
		} : {
			top: this.buttons[3] ? (offset * 60 + 'px') : '-100px'
		};
	}

	getMoreColor() {
		return (this.state.more === 'more' || this.state.more === 'search') ? this.config.unselected : this.config.selected;
	}

	gotConfig(config: MenuConfig) {
		this.config = config;

		this.buttons[0] = config.legend;
		this.buttons[1] = config.filter;
		this.buttons[2] = typeof config.iab !== 'undefined';
		this.buttons[3] = config.more;

		this.buttonCount = 0;

		for (var i = 0, len = this.buttons.length; i < len; i++) {
			if (this.buttons[i]) {
				this.buttonCount++;
			}
		}

		this.space = (window.innerWidth - this.buttonCount * 60) / (this.buttonCount + 1);
	}

	gotState(state: MenuState) {
		this.state = state;
	}

  gotAppState(state: AppState) {
    this.appState = state;
  }

  getIABColor() {
		return (this.appState.iab && !this.configService.mobile) ? this.config.selected : this.config.unselected;
  }

	iabClick() {
    if (this.appState.iab) {
      this.stateService.state = 'map';
    } else {
      if (this.config.iab.url.indexOf('geofence:') > -1) {
        this.mapService.getGeofence(this.config.iab.url.substring(9, this.config.iab.url.length), (url) => {
          this.stateService.openUrl(url, this.config.iab.text);
        }, this);
      } else {
        this.stateService.openUrl(this.config.iab.url, this.config.iab.text);
      }
    }
  }

  get deviceEventType(): string {
    if (this.configService.desktopClass) {
      return 'click';
    } else if (this.configService.mobile) {
      return 'touchend';
    }
  }

  addEventHandlers() {
    const menuButtonList = this.menuButtonList.toArray();
    const eventType = this.deviceEventType;

    for (let i = 0; i < menuButtonList.length; i++) {
      if (i === 0) {
        this.renderer.listen(menuButtonList[i].nativeElement, eventType, () =>  {
          this.stateService.state = this.state.legend;
        });
      } else if (i === 1) {
        this.renderer.listen(menuButtonList[i].nativeElement, eventType, () =>  {
          this.stateService.state = this.state.filter;
        });
      } else if (i === 2) {
        this.renderer.listen(menuButtonList[i].nativeElement, eventType, () =>  {
          this.iabClick();
        });
      } else if (i === 3) {
        this.renderer.listen(menuButtonList[i].nativeElement, eventType, () =>  {
          this.stateService.state = this.state.more;
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/menu/menu.component.ts